export const MANAGERS_ACTIONS = {
  REQUESTED: 'managers/requested',
  SUCCEEDED: 'managers/succeeded',
  FAILED: 'managers/failed',
};

export const REMOVE_MANAGER_ACTIONS = {
  REQUESTED: 'managers/remove/requested',
  SUCCEEDED: 'managers/remove/succeeded',
  FAILED: 'managers/remove/failed',
};

export const CREATE_MANAGER_ACTIONS = {
  REQUESTED: 'managers/create/requested',
  SUCCEEDED: 'managers/create/succeeded',
  FAILED: 'managers/create/failed',
};

export const EDIT_MANAGER_ACTIONS = {
  REQUESTED: 'managers/edit/requested',
  SUCCEEDED: 'managers/edit/succeeded',
  FAILED: 'managers/edit/failed',
};

export const SET_EDIT_MANAGER_ACTIONS = {
  SELECT: 'managers/set/edit/select',
  REMOVE: 'managers/set/edit/remove',
};

export interface ManagersRequested {
  type: string;
}

export const managersRequested = () => ({
  type: MANAGERS_ACTIONS.REQUESTED,
});

export interface ManagersSucceeded {
  type: string;
  payload: { managers: any[] };
}

export const managersSucceeded = (managers: any[]) => ({
  type: MANAGERS_ACTIONS.SUCCEEDED,
  payload: { managers },
});

export interface ManagersFailed {
  error: any;
  type: string;
}

export const managersFailed = (error: any) => ({
  error,
  type: MANAGERS_ACTIONS.FAILED,
});

export interface RemoveManagerRequested {
  type: string;
  payload: { managerId: string };
}

export const removeManagerRequested = (managerId: string) => ({
  type: REMOVE_MANAGER_ACTIONS.REQUESTED,
  payload: { managerId },
});

export interface RemoveManagerSucceeded {
  type: string;
  payload: { managerId: number };
}

export const removeManagerSucceeded = (managerId: number) => ({
  type: REMOVE_MANAGER_ACTIONS.SUCCEEDED,
  payload: { managerId },
});

export const removeManagerFailed = (error: any) => ({
  error,
  type: MANAGERS_ACTIONS.FAILED,
});

export interface CreateManagerRequested {
  type: string;
  payload: { manager: any };
}

export const createManagerRequested = (manager: any) => ({
  type: CREATE_MANAGER_ACTIONS.REQUESTED,
  payload: { manager },
});

export interface CreateManagerSucceeded {
  type: string;
  payload: { manager: any };
}

export const createManagerSucceeded = (manager: any) => ({
  type: CREATE_MANAGER_ACTIONS.SUCCEEDED,
  payload: { manager },
});

export const createManagerFailed = (error: any) => ({
  error,
  type: CREATE_MANAGER_ACTIONS.FAILED,
});

export interface EditManagerRequested {
  type: string;
  payload: { manager: any };
}

export const editManagerRequested = (manager: any) => ({
  type: EDIT_MANAGER_ACTIONS.REQUESTED,
  payload: { manager },
});

export interface EditManagerSucceeded {
  type: string;
  payload: { manager: any };
}

export const editManagerSucceeded = (manager: any) => ({
  type: EDIT_MANAGER_ACTIONS.SUCCEEDED,
  payload: { manager },
});

export const editManagerFailed = (error: any) => ({
  error,
  type: EDIT_MANAGER_ACTIONS.FAILED,
});

export const setEditManager = (manager: any) => ({
  type: SET_EDIT_MANAGER_ACTIONS.SELECT,
  payload: { manager },
});

export const removeEditManager = () => ({
  type: SET_EDIT_MANAGER_ACTIONS.REMOVE,
});

export type ManagersAction =
  | ManagersRequested
  | ManagersFailed
  | ManagersSucceeded
  | ManagersSucceeded
  | RemoveManagerRequested
  | RemoveManagerSucceeded
  | CreateManagerRequested
  | CreateManagerSucceeded
  | EditManagerRequested
  | EditManagerSucceeded;



// WEBPACK FOOTER //
// ./src/scenes/Managers/services/actions.ts